// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"305":"c963720550a20ac6","452":"720e2934ea20cdc3","536":"b3b54b3e3ff373c0","544":"aa26e343f7f9b5ec"}[chunkId] + ".js";
};